import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function DatosEstadisticos() {
  return <ServiceTemplate serviceName="datos-estadisticos" />;
}
